<!-- <partneradmin-unauth-wrapper titleTranslateKey="USER.TENAPOD_EXTERNAL_AUTH.TITLE">
  <ng-container *transloco="let t; read: 'USER.TENAPOD_EXTERNAL_AUTH'">
    <div class="external-auth-card external-auth-fade-in" *ngIf="!errorMessage; else errorBlock">
      <div class="external-auth-spinner-wrap">
        <i class="pi pi-spin pi-spinner external-auth-spinner"></i>
      </div>
      <h2 class="external-auth-headline">{{ t('LOADING') }}</h2>
      <p class="external-auth-subline">{{ t('LOADING_SUBTITLE') }}</p>
    </div>

    <ng-template #errorBlock>
      <div class="external-auth-card external-auth-fade-in">
        <div class="external-auth-error-icon-wrap">
          <i class="pi pi-times-circle external-auth-error-icon"></i>
        </div>
        <h2 class="external-auth-error-headline">{{ t('ERROR_TITLE') }}</h2>
        <p class="external-auth-error-message">{{ errorMessage }}</p>
        <p class="external-auth-redirecting" *ngIf="isRedirecting">{{ t('REDIRECTING') }}</p>
      </div>
    </ng-template>
  </ng-container>
</partneradmin-unauth-wrapper> -->
<div></div>
<p-toast key="tenapod-external-auth-error"></p-toast>
